import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

function ModalBackThirdStep({ show, onUpdate, onCreate, onHide }) {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.modalBack,
  }));
  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>{lang[4]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="mb-2 fs-8 px-4 px-sm-0">{lang[5]}</div>
          <div className="mb-3 pb-3 fs-8">{lang[6]}</div>
          <Row className="gx-2">
            <Col xs={6}>
              <Button
                variant={"outline-primary"}
                className="w-100 py-3"
                onClick={onUpdate}
              >
                {lang[7]}
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                variant={"primary"}
                className="w-100 py-3 fw-bold"
                onClick={onCreate}
              >
                {lang[8]}
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalBackThirdStep;